import React from 'react';
import { NavLink } from 'react-router-dom';
import axios from "axios";
import { useEffect, useState, forwardRef, useImperativeHandle, useRef } from "react";
import Loader from "../components/Loader";
import * as Constants from './Constants';
import {motion, AnimatePresence} from 'framer-motion';
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Trans, useTranslation } from 'react-i18next';

const Footer = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const { register, handleSubmit, reset } = useForm();


    
    useEffect(() => {    
    axios.get(`${Constants.LARAVEL_API_URL}/categories`).then(res => {
        if (res.data.status === 200) {
            setLoading(false);
            setCategories(res.data.categories);
        }
        }).catch();
    }, []);

    const modalRef = useRef()

  const onSubmit = async (data) => {
    await axios.post(`${Constants.LARAVEL_API_URL}/setOrder`, data)
    .then(response => {
        if(response.data.status === 200){
          toast.success(t('your_order_success'));

          reset();
          
          window.setTimeout(function () {
            modalRef.current.close();
          }, 2000);
          
        }
    })
    .catch(function (error) {
        toast.error(t('your_order_error'));
    });
  };
  const {t} = useTranslation();
  const submit_btn = t('submit_btn');
    
  return (
    <footer>
        <Modal ref={modalRef}>
          <h2>{t('set_your_order_title')}</h2>
          <form onSubmit={handleSubmit(onSubmit)}>
                <fieldset className="inputField">
                    <i class="fa-solid fa-user"></i>
                    <input                        
                        required
                        className="modalInput"
                        type="text"
                        id="name"
                        name="name"
                        placeholder={t('modal_name')}
                        autoComplete='off'
                        {...register("name")}
                    />
                </fieldset>                    
                <fieldset className="inputField">
                    <i class="fa-solid fa-phone-volume"></i>
                    <input
                        required
                        className="modalInput"
                        type="phone"
                        id="phone"
                        name="phone"
                        autoComplete='off'
                        placeholder={t('modal_phone')}
                        {...register("phone")}
                    />
                </fieldset>
                <fieldset className="inputField">
                    <i class="fas fa-envelope"></i>
                    <input
                        required
                        className="modalInput"
                        type="email"
                        id="email"
                        name="email"
                        autoComplete='off'
                        placeholder={t('modal_email')}
                        {...register("email")}
                    />
                </fieldset>
                <fieldset className="inputField">
                    <i class="fas fa-comment"></i>
                    <textarea
                        required
                        className="modalInput modalTextarea"
                        type="text"
                        id="comment"
                        name="comment"
                        autoComplete='off'
                        placeholder={t('modal_comment')}
                        {...register("comment")}
                    />
                </fieldset>
                <button type="submit" className="modalInputBtn">{t('send_request_btn')}</button>
                <ToastContainer
                    position="top-center"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <div 
                className='modalClose'
                onClick={() => {modalRef.current.close();}}
                >x</div>
            </form> 
        </Modal>
            <div className="container">
                <div className="footer">
                    <div className="footerCategoryWrap">
                        <h3>{t('product_category_footer')}</h3>
                        <ul>
                            {loading ? <Loader width={122} height={122} /> :categories.map((category) => (
                                <li key={category.id}>
                                    <NavLink to={`/catalog/${category.slug}`} props={category.name}>{category.name}</NavLink>
                                </li>
                            ))}
                        </ul>
                        <h3>{t('information_footer')}</h3>
                        <ul>
                            <li>
                                <NavLink
                                to="/license"
                                >{t('licence_page_title')}</NavLink>
                            </li>
                            <li>
                                <NavLink 
                                to="/about"
                                >{t('about_page_title')}</NavLink>
                            </li>
                            <li>
                                <NavLink 
                                to="/contacts"
                                >{t('contacts_page_title')}</NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className="footerLogoWrap">
                        <div className="footerLogo">
                            <NavLink to="/">
                                <img
                                src="/uploads/images/footerLogo.png"
                                width={266}
                                height={52}
                                alt="Оптические технологии"
                                />
                            </NavLink><br />
                            <p>{t('slogan')}</p>
                        </div>
                        <div className="footerSocial">
                            <a href="https://www.linkedin.com/company/optech-2011/" target='_blank' rel="noreferrer"><i className="fab fa-linkedin"></i></a>
                            <a href="https://facebook.com" target='_blank' rel="noreferrer"><i className="fab fa-facebook"></i></a>
                            <a href="https://www.instagram.com/optech.kz/" target='_blank' rel="noreferrer"><i className="fab fa-instagram-square"></i></a>
                            <a href="https://www.youtube.com/@optechkz" target='_blank' rel="noreferrer"><i className="fab fa-youtube"></i></a>
                        </div>
                    </div>
                    <div className="footerContactsWrap">
                        <h3>{t('contacts_page_title')}</h3>
                        <div className="footerContactItem">
                            <a href="tel:+77717595949"><i className="fas fa-phone-volume" aria-hidden="true"></i>+7 (771) 759-59-49 </a>
                        </div>
                        <div className="footerContactItem">
                            <a href="tel:+77272902098"><i className="fas fa-phone-volume" aria-hidden="true"></i>+7 (727) 290 20 98</a>
                        </div>
                        <div className="footerContactItem">
                            <a href="mailto:info@optech.kz"><i className="fas fa-envelope" aria-hidden="true"></i>info@optech.kz</a>
                        </div>
                        <div className="footerContactItem">
                            <p><i class="fas fa-clock"></i>Пн - Пт: 09:00 AM - 18:00</p>
                        </div>
                        <div className="footerContactItem">
                            <a href="https://go.2gis.com/sijyi" target="_blank" rel="noreferrer"><i className="fas fa-map-marker-alt"></i>г. Алматы, ул. Кенесары хана, <br/>дом 83/1, 1 этаж, офис 1Б</a>
                        </div>
                        <div
                            className="footerBtn"
                            onClick={() => modalRef.current.open()}
                        ><Trans
                        i18nKey={submit_btn}
                        components={{1: <br />}}
                    ></Trans>
                        </div>
                    </div>
                </div>
                <div className="copyrightWrap">
                    <div className="footerCopyYear">2024</div>
                    <div className="footerCopyright">COPYRIGHT © {t('copyright_footer')} - <NavLink href="/">https://optech.kz</NavLink></div>
                </div>
            </div>
            <div id="mobile_bar">
                <div class="mobile_bar_wrapper">
                    <div class="mobile_bar_item">
                        <a href="https://wa.me/77717595949" target="_blank" rel="noreferrer">
                            <span class="mobile_bar_icons_inner">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" id="whatsapp-icon" width="100%" height="28px"><title>Forma 1</title><path d="M28 13.639c0 7.533-6.154 13.64-13.745 13.64-2.41 0-4.675-.616-6.645-1.697L0 28l2.481-7.318a13.502 13.502 0 0 1-1.972-7.043C.509 6.106 6.663 0 14.255 0 21.847 0 28 6.106 28 13.639zM14.255 2.172c-6.373 0-11.557 5.144-11.557 11.467 0 2.51.818 4.833 2.201 6.724l-1.444 4.258 4.442-1.411a11.546 11.546 0 0 0 6.358 1.896c6.372 0 11.556-5.143 11.556-11.466 0-6.323-5.184-11.468-11.556-11.468zm6.941 14.609c-.085-.14-.31-.223-.646-.391-.338-.167-1.995-.976-2.303-1.087-.309-.111-.534-.167-.758.167-.224.335-.87 1.088-1.067 1.311-.197.223-.393.251-.73.084-.337-.167-1.423-.521-2.71-1.659-1.001-.886-1.678-1.98-1.874-2.316-.196-.334-.021-.515.148-.681.152-.15.337-.391.505-.586.169-.195.225-.334.337-.557.113-.224.056-.419-.028-.586-.084-.167-.759-1.812-1.039-2.482-.281-.669-.561-.557-.758-.557-.196 0-.421-.029-.646-.029-.225 0-.59.084-.899.419-.308.334-1.179 1.143-1.179 2.788 0 1.645 1.207 3.235 1.376 3.458.168.222 2.33 3.708 5.756 5.047 3.426 1.338 3.426.892 4.043.836.618-.056 1.993-.809 2.275-1.589.281-.782.281-1.451.197-1.59z"></path></svg>
                            </span>WhatsApp
                        </a>
                    </div>
                    <div class="mobile_bar_item">
                        <a target="_parent" href="tel:+77717595949">
                            <span class="mobile_bar_icons_inner">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 27" id="phone-icon" width="100%" height="100%"><title>Shape 1</title><path d="M22.35 16.726c-.554-.576-1.222-.884-1.929-.884-.702 0-1.376.302-1.952.878l-1.803 1.795c-.149-.08-.297-.154-.44-.228-.205-.103-.399-.2-.565-.302-1.689-1.071-3.224-2.468-4.697-4.274-.713-.9-1.192-1.658-1.541-2.428.468-.427.902-.871 1.324-1.299.16-.159.32-.325.48-.484 1.198-1.197 1.198-2.747 0-3.944L9.669 4.001c-.177-.177-.36-.359-.531-.542A26.208 26.208 0 0 0 8.065 2.4c-.553-.548-1.215-.838-1.912-.838-.696 0-1.369.29-1.94.838l-.011.011-1.941 1.954a4.17 4.17 0 0 0-1.238 2.65c-.137 1.664.354 3.214.73 4.229.925 2.49 2.306 4.798 4.366 7.271 2.5 2.98 5.507 5.334 8.943 6.992 1.313.621 3.065 1.356 5.022 1.482.12.005.245.011.36.011 1.318 0 2.425-.473 3.292-1.413.006-.012.018-.017.023-.029.297-.359.639-.684.999-1.031.245-.234.496-.479.742-.735.565-.587.862-1.271.862-1.972 0-.707-.303-1.385-.879-1.955zm2.043 6c-.006 0-.006.006 0 0-.223.239-.451.456-.697.695-.37.354-.747.724-1.101 1.14-.576.615-1.255.906-2.146.906-.085 0-.177 0-.262-.006-1.695-.108-3.27-.769-4.452-1.333-3.23-1.561-6.066-3.778-8.423-6.588-1.946-2.342-3.247-4.507-4.109-6.832-.531-1.419-.725-2.525-.639-3.567.057-.667.314-1.22.787-1.693l1.946-1.943c.28-.262.577-.405.868-.405.359 0 .65.217.833.399l.017.017c.348.325.679.661 1.027 1.02.177.183.36.365.543.553l1.558 1.556c.604.604.604 1.162 0 1.766-.166.166-.326.331-.491.49-.48.491-.936.947-1.433 1.391-.011.011-.023.017-.028.028-.491.491-.4.969-.297 1.294l.017.051c.405.98.976 1.904 1.843 3.003l.006.006c1.575 1.938 3.236 3.448 5.068 4.604.234.149.474.268.702.382.205.103.399.2.565.302.023.012.046.029.068.04.194.097.377.143.565.143.474 0 .771-.297.868-.394l1.952-1.948c.194-.194.502-.428.861-.428.354 0 .645.222.822.416l.012.012 3.144 3.139c.588.582.588 1.18.006 1.784zm-8.8-16.303a7.231 7.231 0 0 1 3.937 2.04 7.256 7.256 0 0 1 2.044 3.932.765.765 0 0 0 .759.638c.045 0 .085-.006.131-.011a.77.77 0 0 0 .633-.889 8.783 8.783 0 0 0-2.471-4.759 8.807 8.807 0 0 0-4.765-2.467.774.774 0 0 0-.89.627.76.76 0 0 0 .622.889zm12.395 5.487a14.455 14.455 0 0 0-4.069-7.835A14.487 14.487 0 0 0 16.072.012a.768.768 0 0 0-.885.627.774.774 0 0 0 .634.889 12.97 12.97 0 0 1 7.014 3.63 12.904 12.904 0 0 1 3.635 7.003.765.765 0 0 0 .89.627.756.756 0 0 0 .628-.878z"></path></svg>
                            </span>{t('footer_call_title')}
                        </a>
                    </div>
                </div>
                </div>
        </footer>
  )

}

export default Footer

const Modal = forwardRef(( props, ref ) => {  
    const [openModal, setOpenModal] = useState(false);

    useImperativeHandle(ref, () => {
      return{
        open: () => setOpenModal(true),
        close: () => setOpenModal(false)
      }
    })

    return (
      <AnimatePresence>
        {openModal && (
              <>
              <motion.div 
                  initial={{
                      opacity:0,
                  }}
                  animate={{
                      opacity:1,
                      transition:{
                          duration:0.3,
                      }
                  }}
                  exit={{
                      opacity:0,
                      transition:{
                          delay:0.3,
                      },
                  }}
                  onClick={() => setOpenModal(false)}
                  className='modal-backdrop' 
              />
              <motion.div 
                  initial={{
                      scale:0,
                  }}
                  animate={{
                      scale:1,
                      transition:{
                          duration:0.3,
                      },
                  }}
                  exit={{
                      scale:0,
                      transition:{
                          delay:0.3,
                      },
                  }}
                  className='modal-content-wrapper'
              >
                  <motion.div 
                      initial={{
                          x:100,
                          opacity:0,
                      }}
                      animate={{
                          x:0,
                          opacity:1,
                          transition:{
                              delay:0.3,
                              duration:0.3,
                          },
                      }}
                      exit={{
                          x:100,
                          opacity:0,
                          transition:{
                              duration:0.3,
                          },
                      }}
                      className='modal-content'
                  >
                      {props.children}
                  </motion.div>
              </motion.div>
          </>
          )}
      </AnimatePresence>
    )
  }
);

